import { Box, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { FaInbox } from "react-icons/fa";
import { BoardColumn, Lead } from "../../../models/Lead";
import { crm, Pill } from "./crmTheme";
import LeadCard from "./LeadCard";

const LeadColumn = ({
  column,
  onDragStartCard,
  onDropInColumn,
  onLeadClick,
  onLeadDelete,
}: {
  column: BoardColumn;
  onDragStartCard: (e: React.DragEvent, lead: Lead) => void;
  onDropInColumn: (e: React.DragEvent, column: BoardColumn) => void;
  onLeadClick: (lead: Lead) => void;
  onLeadDelete: (lead: Lead) => void;
}) => {
  const [isOver, setIsOver] = useState(false);
  const accentColor = column.status.color || crm.brand;

  return (
    <Flex
      flexDir="column"
      minW="300px"
      maxW="300px"
      h="100%"
      bg={isOver ? crm.brandSoft : crm.columnBg}
      borderRadius="14px"
      border={isOver ? `2px dashed ${crm.brand}` : "2px solid transparent"}
      transition="background-color .12s ease, border .12s ease"
      overflow="hidden"
      onDragOver={(e) => {
        e.preventDefault();
        setIsOver(true);
      }}
      onDragLeave={() => setIsOver(false)}
      onDrop={(e) => {
        setIsOver(false);
        onDropInColumn(e, column);
      }}
    >
      {/* Top accent bar */}
      <Box h="3px" bg={accentColor} borderRadius="14px 14px 0 0" />

      {/* Column header */}
      <Flex
        align="center"
        justify="space-between"
        px="14px"
        py="10px"
      >
        <Flex align="center" gap="8px">
          <Box
            w="8px"
            h="8px"
            borderRadius="full"
            bg={accentColor}
            flexShrink={0}
          />
          <Text fontWeight="700" fontSize="sm" color={crm.text}>
            {column.status.name}
          </Text>
        </Flex>
        <Pill bg={crm.surface} color={crm.textMuted}>
          {column.leads.length}
        </Pill>
      </Flex>

      {/* Cards area */}
      <Flex
        flexDir="column"
        gap="12px"
        p="12px"
        overflowY="auto"
        flex="1"
        minH="120px"
      >
        {column.leads.map((lead) => (
          <LeadCard
            key={lead.id}
            lead={lead}
            onDragStart={onDragStartCard}
            onClick={onLeadClick}
            onDelete={onLeadDelete}
          />
        ))}
        {column.leads.length === 0 && (
          <Flex
            flex="1"
            flexDir="column"
            align="center"
            justify="center"
            color={crm.textFaint}
            fontSize="sm"
            gap="8px"
            minH="100px"
            opacity={0.7}
          >
            <FaInbox size={20} />
            <Text>Arraste leads para cá</Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default LeadColumn;
